import React, { useState } from "react";
import "../../styles/Edit.css";
import Select from "react-select";

const Edit = ({ onClose, selectedCount, onSave }) => {
  const properties = [
    "Company",
    "Website",
    "Industry",
    "Relationship Type",
    "Lead Status",
    "Lead Source",
    "LinkedIn",
    "Company Stage",
    "Legal Type",
    "Employee Count",
    "Annual Revenue",
    "Primary Contact",
    "Job Title",
    "Email",
    "Phone",
    "Assign",
  ];

  const dropdownOptions = {
    "Relationship Type": [
        // CLIENT, PARTNER, SUPPLIER, VENDOR, DISTRIBUTOR, RESELLER,
        // CONTRACTOR, CONSULTANT, SERVICE_PROVIDER, INVESTOR,
        // MANUFACTURER, OTHER
      "Client", "Partner", "Supplier", "Vendor", "Distributor", "Reseller",
      "Contractor", "Consultant", "Service Provider", "Investor", "Manufacturer", "Other"
    ],
    "Lead Status": [
       "NEW", "CONTACTED", "QUALIFIED", "LOST", "WON", "OTHER"
      
    ],
    "Lead Source": [
      "WEBSITE", "REFERRAL", "PARTNER", "SOCIAL_MEDIA", "EMAIL", "CALL", "OTHER"
      
    ],
    "Company Stage": ["Startup", "Small", "Medium", "Large", "Enterprise", "Other"],
    "Legal Type": [
      "Sole Proprietorship", "Partnership Firm", "LLP", "Private Limited",
      "Public Limited Company (PLC)", "One Person Company (OPC)", "Joint Venture",
      "Non-Profit", "Government Entity", "Other"
    ],
    "Employee Count": [
      "1-10", "11-50", "51-100", "101-250", "251-500",
      "501-1000", "1001-5000", "5001-10,000", "10,000+"
    ],
    "Annual Revenue": [
      "$1M", "$1M - $5M", "$5M - $10M", "$10M - $50M", "$50M - $100M",
      "$100M - $500M", "$500M - $1B", "$1B - $5B", "$5B - $10B", "$10B+"
    ],
    Industry: [
        
        "IT", "FINANCE", "HEALTHCARE", "EDUCATION", "MANUFACTURING", "RETAIL", "OTHER"
    
    ],
    Assign: ["No Owner", "Admin", "Team Member 1", "Team Member 2"]
  };

  const textOnlyFields = ["Company", "Primary Contact", "Job Title"];

  const [property, setProperty] = useState("Company");
  const [value, setValue] = useState("");

  // 🧩 Frontend → Backend field name mapping
  const fieldNameMapping = {
    "Company": "companyName",
    "Website": "websiteUrl",
    "Industry": "industry",
    "Relationship Type": "relationshipType",
    "Lead Status": "leadStatus",
    "Lead Source": "leadSource",
    "LinkedIn": "linkedInUrl",
    "Company Stage": "companyStage",
    "Legal Type": "legalType",
    "Employee Count": "employeeCount",
    "Annual Revenue": "annualRevenue",
    "Primary Contact": "primaryContact",
    "Job Title": "jobTitle",
    "Email": "email",
    "Phone": "phone",
    "Assign": "contactOwner"
  };

  // 🧩 Frontend → Backend enum value mapping
  const enumValueMapping = {
    "Industry": {
      "Information Technology (IT)": "IT",
      "Finance / Accounting": "FINANCE",
      "Healthcare / Medical": "HEALTHCARE",
      "Education / Training": "EDUCATION",
      "Manufacturing / Production": "MANUFACTURING",
      "Retail / Sales": "RETAIL",
      "Other": "OTHER",
      "Human Resources (HR)": "HR"
    },
    "Relationship Type": {
      "Client": "CLIENT",
      "Partner": "PARTNER",
      "Supplier": "SUPPLIER",
      "Vendor": "VENDOR",
      "Distributor": "DISTRIBUTOR",
      "Reseller": "RESELLER",
      "Contractor": "CONTRACTOR",
      "Consultant": "CONSULTANT",
      "Service Provider": "SERVICE_PROVIDER",
      "Investor": "INVESTOR",
      "Manufacturer": "MANUFACTURER",
      "Other": "OTHER"
    },
    "Lead Status": {
      "New": "NEW",
      // "Prospect": "PROSPECT",
      "Contacted": "CONTACTED",
      "Qualified Lead": "QUALIFIED",
      // "Unqualified Lead": "UNQUALIFIED_LEAD",
      // "Nurturing / Follow-Up": "FOLLOW_UP",
      // "Meeting Scheduled": "MEETING_SCHEDULED",
      // "Proposal / Quote Sent": "PROPOSAL_SENT",
      // "Negotiation / In Discussion": "NEGOTIATION",
      // "Contract Sent": "CONTRACT_SENT",
      "Won / Customer": "WON",
      "Lost": "LOST",
      // "On Hold": "ON_HOLD",
      "Other": "OTHER"
    },
    "Lead Source": {
  "Website": "WEBSITE",
  "Referral": "REFERRAL",
  "Partner": "PARTNER",
  "Social Media": "SOCIAL_MEDIA",
  "Email": "EMAIL",
  "Call": "CALL",
  "Other": "OTHER"
},
    "Company Stage": {
      "Startup": "STARTUP",
      "Small": "SMALL",
      "Medium": "MEDIUM",
      "Large": "LARGE",
      "Enterprise": "ENTERPRISE",
      "Other": "OTHER"
    },
    "Legal Type": {
      "Sole Proprietorship": "SOLE_PROPRIETORSHIP",
      "Partnership Firm": "PARTNERSHIP_FIRM",
      "LLP": "LLP",
      "Private Limited": "PRIVATE_LIMITED",
      "Public Limited Company (PLC)": "PUBLIC_LIMITED",
      "One Person Company (OPC)": "OPC",
      "Joint Venture": "JOINT_VENTURE",
      "Non-Profit": "NON_PROFIT",
      "Government Entity": "GOVERNMENT_ENTITY",
      "Other": "OTHER"
    },
    "Employee Count": {
      "1-10": "RANGE_1_10",
      "11-50": "RANGE_11_50",
      "51-100": "RANGE_51_100",
      "101-250": "RANGE_101_250",
      "251-500": "RANGE_251_500",
      "501-1000": "RANGE_501_1000",
      "1001-5000": "RANGE_1001_5000",
      "5001-10,000": "RANGE_5001_10000",
      "10,000+": "RANGE_10000_PLUS"
    },
    "Annual Revenue": {
      "$1M": "BELOW_1M",
      "$1M - $5M": "RANGE_1M_5M",
      "$5M - $10M": "RANGE_5M_10M",
      "$10M - $50M": "RANGE_10M_50M",
      "$50M - $100M": "RANGE_50M_100M",
      "$100M - $500M": "RANGE_100M_500M",
      "$500M - $1B": "RANGE_500M_1B",
      "$1B - $5B": "RANGE_1B_5B",
      "$5B - $10B": "RANGE_5B_10B",
      "$10B+": "ABOVE_10B"
    }
  };

  const handleChange = (e) => {
    let val = e.target.value;

    if (property === "Phone") {
      val = val.replace(/\D/g, "");
      if (val.length === 12 && val.startsWith("91")) val = val.slice(2);
      if (val.length === 11 && val.startsWith("0")) val = val.slice(1);
      if (val.length > 10) val = val.slice(0, 10);
    } else if (textOnlyFields.includes(property)) {
      val = val.replace(/[^a-zA-Z\s]/g, "");
    }

    setValue(val);
  };

  const handleUpdate = () => {
    if (!value) {
      alert("Please enter a value to update ❌");
      return;
    }

    if (property === "Phone" && value.length !== 10) {
      alert("Phone number must be exactly 10 digits ❌");
      return;
    }

    if (property === "Email" && !/^\S+@\S+\.\S+$/.test(value)) {
      alert("Invalid email format ❌");
      return;
    }

    if (property === "LinkedIn" && !/^https?:\/\/(www\.)?linkedin\.com\/.+$/.test(value)) {
      alert("Invalid LinkedIn URL ❌");
      return;
    }

    const backendField = fieldNameMapping[property] || property;
    let backendValue = value;

    if (enumValueMapping[property]) {
      backendValue = enumValueMapping[property][value] || value;
    }

    console.log("🧾 Sending to backend:", {
      [backendField]: backendValue,
    });

    onSave({ [backendField]: backendValue });
    onClose();
  };

  const isDropdown = dropdownOptions.hasOwnProperty(property);

  return (
    <div className="modal-overlay">
      <div className="modal-content edit-modal">
        <div className="modal-header">
          <h2>
            Bulk edit {selectedCount} {selectedCount === 1 ? "record" : "records"}
          </h2>
          <button className="close-btn" onClick={onClose}>×</button>
        </div>

        <div className="modal-body">
          <label>Property to update</label>
          <select value={property} onChange={(e) => setProperty(e.target.value)}>
            {properties.map((prop) => (
              <option key={prop}>{prop}</option>
            ))}
          </select>

          <label style={{ marginTop: "10px" }}>{property}</label>
          {isDropdown ? (
            <Select
              options={dropdownOptions[property].map(v => ({ value: v, label: v }))}
              value={value ? { value, label: value } : null}
              onChange={(selected) => setValue(selected.value)}
              menuPlacement="bottom"
              menuShouldScrollIntoView={true}
              styles={{ menu: (provided) => ({ ...provided, zIndex: 9999 }) }}
            />
          ) : (
            <input
              type={property === "Email" ? "email" : property === "Phone" ? "tel" : "text"}
              placeholder={`Enter new ${property}`}
              value={value}
              onChange={handleChange}
            />
          )}
        </div>

        <div className="modal-footer">
          <button className="update-btn" onClick={handleUpdate}>Update</button>
          <button
            className="cancel-btn"
            onClick={() => { setProperty("Company"); setValue(""); }}
          >
            Cancel
          </button>
        </div>
      </div>
    </div>
  );
};

export default Edit;
